import {Body2} from '@ui/atoms/typography';
import {Colors} from '@ui/interface';
import React, {CSSProperties, FC, ReactNode, useState} from 'react';

interface HoverTooltipProps {
  children: ReactNode;
  tooltipText: string;
  tooltipTextKind?: Colors;
  tooltipTextSize?: string;
  show?: boolean;
  className?: string;
  tooltipStyle?: CSSProperties;
  tooltipTextStyle?: CSSProperties;
  showHoverBackground?: boolean;
}
export const HoverTooltip: FC<HoverTooltipProps> = ({
  children,
  show,
  tooltipText,
  className,
  tooltipTextKind,
  tooltipTextSize,
  tooltipStyle,
  tooltipTextStyle,
  showHoverBackground = true,
}) => {
  const [isHovering, setIsHovering] = useState(false);

  // Check if className includes a background color
  const hasBgColor = className?.includes('bg-');

  // Combine default and custom classes
  const tooltipClasses = `
    absolute top-9 -right-6 rounded-md
    ${hasBgColor ? '' : 'bg-gray-700'}
    ${className || 'text-alwaysWhite py-1 px-2'}
  `.trim();

  return (
    <div
      className="relative"
      onClick={() => setIsHovering(false)}
      onFocus={() => setIsHovering(true)}
      onBlur={() => setIsHovering(false)}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}>
      <div className="z-10">{children}</div>
      {isHovering && showHoverBackground && (
        <div
          data-testid="hover-tooltip-background"
          style={{zIndex: -4}}
          className={
            'bg-[#F6F6F8] -top-[50%] -left-[50%] z-0 w-full absolute px-4 py-4 rounded-full '
          }
        />
      )}

      {(isHovering || show) && (
        <div role="tooltip" className={tooltipClasses} style={tooltipStyle}>
          <Body2
            kind={tooltipTextKind || 'white'}
            size={tooltipTextSize || '12px'}
            style={{whiteSpace: 'nowrap', ...tooltipTextStyle}}>
            {tooltipText}
          </Body2>
        </div>
      )}
    </div>
  );
};
